module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "btn-group dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-black",
    attrs: {
      "data-toggle": "dropdown",
      "tabindex": "1",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o m-r-xs"
  }), _vm._v(" Cadastrar edital "), _c('span', {
    staticClass: "m-l-sm caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu no-padder"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'edital.novo',
        query: {
          leilao: _vm.leilao.id,
          tipo: _vm.TIPOS_EDITAL.notificacao
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-fw"
  }), _vm._v(" Edital de notificação\n      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'edital.novo',
        query: {
          leilao: _vm.leilao.id,
          tipo: _vm.TIPOS_EDITAL.leilao
        }
      },
      "tabindex": "2"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o fa-fw"
  }), _vm._v(" Edital de leilão\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51680685","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/BtnEdital.vue
// module id = 1671
// module chunks = 17